import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import "./PendingDotsSkeleton.scss";

interface IPendingDotsSkeletonProps {
  translationKey: string;
  invisible?: boolean;
}

export const PendingDotsSkeleton: FunctionComponent<IPendingDotsSkeletonProps> = ({ translationKey }) => {
  const { t } = useTranslation();

  const pendingDotsTemplate = () => (
    <div className="pending-dots-skeleton">
      <span className="pending-dots-skeleton-text">{t(translationKey)}</span>

      <div className="pending-dots-skeleton-bouncing-dots">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
    </div>
  );

  return pendingDotsTemplate();
};
